// 图表类型
export var SeriesType;
(function (SeriesType) {
    SeriesType["BAR"] = "bar";
    SeriesType["LINE"] = "line";
})(SeriesType || (SeriesType = {}));
